var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      height: "44px"
    }
  }, [_c("div", [_c("history", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.userInfo.id,
      expression: "!!userInfo.id"
    }]
  })], 1), _c("div", {
    staticClass: "new-chat-button",
    on: {
      click: _vm.handleNewChat
    }
  }, [_c("svg-icon", {
    staticClass: "m-r-4",
    attrs: {
      name: "new-chat",
      size: "14"
    }
  }), _c("div", [_vm._v("新建会话")])], 1)]), _c("chat", {
    key: "chat"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };